import React, { FunctionComponent } from "react";
import styles from "./ContactButton.module.css";

/**
 * ContactButton Props
 * -------------------
 * color: Text color of the button label.
 * title: Button text content.
 * clicked: Callback function triggered when the button is clicked.
 * backgroundColor: Background + border color of the button.
 */
type Props = {
  color: string;
  title: string;
  clicked: () => void;
  backgroundColor: string;
};

/**
 * ContactButton Component
 * ------------------------
 * A customizable button component used in contact or call-to-action areas.
 * 
 * - Applies dynamic styling via inline styles.
 * - Uses external CSS module for layout & base button styling.
 * - Keeps full compatibility with parent components.
 */
const ContactButton: FunctionComponent<Props> = ({
  color,
  title,
  clicked,
  backgroundColor,
}) => {
  return (
    <div>
      <button
        className={styles.button}
        onClick={clicked}
        style={{
          color: color,                // Text color
          borderColor: backgroundColor, // Uses same color for outline
          backgroundColor: backgroundColor, // Button background
          fontWeight: "bold",          // Makes button text bold
        }}
      >
        {title}
      </button>
    </div>
  );
};

export default ContactButton;
